import React, { useEffect } from 'react';
import Header from './Header';
import Advertisement from './Advertisement';
import Footer from './Footer';
import CulinaryCareerPortal from './CulinaryCareerPortal';
import CulinaryConnectHero from './CulinaryConnectHero';
import './ClickaCook.css';

function ClickaCook() {
  useEffect(
    ()=>{
      document.title="ClickaCook"
    },[]
  );

  const contentStyles = {
    position: 'relative',
    zIndex: 10,
    maxWidth: '1200px',
    margin: '0 auto',
    padding: '48px 16px 50px',
    display: 'flex',
    flexDirection: 'column',
    gap: '2.5rem',
  };

  return (
    <div 
      className="clickacook-page"
      style={{
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #FF6B35 0%, #FF8E53 50%, #FFD700 100%)',
        position: 'relative',
        overflow: 'hidden',
        fontFamily: "'Inter', sans-serif",
        color: '#2c3e50',
        lineHeight: '1.7'
      }}
    >
      {/* Animated Background Overlay */}
      <div 
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          background: 'linear-gradient(135deg, rgba(255, 107, 53, 0.3) 0%, rgba(255, 215, 0, 0.2) 100%)',
          animation: 'backgroundShift 8s ease-in-out infinite',
          zIndex: 0
        }}
      />

      {/* Global Background Elements */}
      <div 
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          pointerEvents: 'none',
          zIndex: 0,
          overflow: 'hidden'
        }}
      >
        {/* Floating Ingredients */}
        <div 
          style={{ 
            position: 'absolute',
            top: '10%', 
            left: '5%', 
            fontSize: '2.5rem',
            opacity: 0.7,
            filter: 'drop-shadow(2px 2px 4px rgba(0,0,0,0.3))',
            animation: 'floatIngredient 6s ease-in-out infinite'
          }}
        >🍳</div>
        
        <div 
          style={{ 
            position: 'absolute',
            top: '15%', 
            right: '8%', 
            fontSize: '2.5rem',
            opacity: 0.7,
            filter: 'drop-shadow(2px 2px 4px rgba(0,0,0,0.3))',
            animation: 'floatIngredient 6s ease-in-out infinite 1s'
          }}
        >🥘</div>
        
        <div 
          style={{ 
            position: 'absolute',
            bottom: '25%', 
            left: '3%', 
            fontSize: '2.5rem',
            opacity: 0.7,
            filter: 'drop-shadow(2px 2px 4px rgba(0,0,0,0.3))',
            animation: 'floatIngredient 6s ease-in-out infinite 2s'
          }}
        >👨‍🍳</div>
        
        <div 
          style={{ 
            position: 'absolute',
            bottom: '20%', 
            right: '12%', 
            fontSize: '2.5rem',
            opacity: 0.7,
            filter: 'drop-shadow(2px 2px 4px rgba(0,0,0,0.3))',
            animation: 'floatIngredient 6s ease-in-out infinite 3s'
          }}
        >🥗</div>
        
        <div 
          style={{ 
            position: 'absolute',
            top: '35%', 
            left: '15%', 
            fontSize: '2.5rem',
            opacity: 0.7,
            filter: 'drop-shadow(2px 2px 4px rgba(0,0,0,0.3))',
            animation: 'floatIngredient 6s ease-in-out infinite 4s'
          }}
        >🍲</div>
        
        <div 
          style={{ 
            position: 'absolute',
            top: '45%', 
            right: '5%', 
            fontSize: '2.5rem',
            opacity: 0.7,
            filter: 'drop-shadow(2px 2px 4px rgba(0,0,0,0.3))',
            animation: 'floatIngredient 6s ease-in-out infinite 5s'
          }}
        >🥣</div>

        {/* Additional Floating Elements */}
        <div 
          style={{ 
            position: 'absolute',
            top: '70%', 
            left: '10%', 
            fontSize: '2rem',
            opacity: 0.6,
            filter: 'drop-shadow(2px 2px 4px rgba(0,0,0,0.3))',
            animation: 'floatIngredient 7s ease-in-out infinite 6s'
          }}
        >🍛</div>
        
        <div 
          style={{ 
            position: 'absolute',
            top: '80%', 
            right: '15%', 
            fontSize: '2.2rem',
            opacity: 0.6,
            filter: 'drop-shadow(2px 2px 4px rgba(0,0,0,0.3))',
            animation: 'floatIngredient 5s ease-in-out infinite 7s'
          }}
        >🍚</div>

        {/* Background Bubbles */}
        <div 
          style={{ 
            width: '30px', 
            height: '30px', 
            position: 'absolute',
            top: '20%', 
            left: '15%', 
            background: 'radial-gradient(circle at 30% 30%, rgba(255,255,255,0.4), rgba(255,255,255,0.1))',
            borderRadius: '50%',
            animation: 'bubbleFloat 8s ease-in-out infinite',
            boxShadow: '0 0 20px rgba(255,255,255,0.3)'
          }}
        />
        
        <div 
          style={{ 
            width: '50px', 
            height: '50px', 
            position: 'absolute',
            top: '30%', 
            right: '20%', 
            background: 'radial-gradient(circle at 30% 30%, rgba(255,255,255,0.4), rgba(255,255,255,0.1))',
            borderRadius: '50%',
            animation: 'bubbleFloat 9s ease-in-out infinite 2s',
            boxShadow: '0 0 25px rgba(255,255,255,0.4)'
          }}
        />
        
        <div 
          style={{ 
            width: '25px', 
            height: '25px', 
            position: 'absolute',
            bottom: '40%', 
            left: '25%', 
            background: 'radial-gradient(circle at 30% 30%, rgba(255,255,255,0.4), rgba(255,255,255,0.1))',
            borderRadius: '50%',
            animation: 'bubbleFloat 7s ease-in-out infinite 4s',
            boxShadow: '0 0 15px rgba(255,255,255,0.3)'
          }}
        />

        {/* Additional Bubbles */}
        <div 
          style={{ 
            width: '35px', 
            height: '35px', 
            position: 'absolute',
            top: '60%', 
            right: '15%', 
            background: 'radial-gradient(circle at 30% 30%, rgba(255,255,255,0.3), rgba(255,255,255,0.1))',
            borderRadius: '50%',
            animation: 'bubbleFloat 10s ease-in-out infinite 1s',
            boxShadow: '0 0 18px rgba(255,255,255,0.3)'
          }}
        />

        {/* Steam Effects */}
        <div 
          style={{ 
            width: '60px', 
            height: '60px', 
            position: 'absolute',
            bottom: '8%', 
            left: '45%', 
            background: 'linear-gradient(to bottom, transparent, rgba(255,255,255,0.4))',
            borderRadius: '50%',
            animation: 'steamRise 6s ease-in-out infinite',
            filter: 'blur(8px)'
          }}
        />
        
        <div 
          style={{ 
            width: '40px', 
            height: '40px', 
            position: 'absolute',
            bottom: '12%', 
            left: '48%', 
            background: 'linear-gradient(to bottom, transparent, rgba(255,255,255,0.3))',
            borderRadius: '50%',
            animation: 'steamRise 7s ease-in-out infinite 2s',
            filter: 'blur(6px)'
          }}
        />

        {/* Additional Steam */}
        <div 
          style={{ 
            width: '50px', 
            height: '50px', 
            position: 'absolute',
            bottom: '25%', 
            right: '40%', 
            background: 'linear-gradient(to bottom, transparent, rgba(255,255,255,0.3))',
            borderRadius: '50%',
            animation: 'steamRise 8s ease-in-out infinite 4s',
            filter: 'blur(7px)'
          }}
        />

        {/* Particles */}
        <div 
          style={{ 
            width: '3px', 
            height: '3px', 
            position: 'absolute',
            left: '10%', 
            top: '5%',
            background: 'rgba(255, 255, 255, 0.8)',
            borderRadius: '50%',
            animation: 'particleFloat 12s linear infinite'
          }}
        />
        
        <div 
          style={{ 
            width: '2px', 
            height: '2px', 
            position: 'absolute',
            left: '20%', 
            top: '15%',
            background: 'rgba(255, 255, 255, 0.6)',
            borderRadius: '50%',
            animation: 'particleFloat 15s linear infinite 2s'
          }}
        />

        {/* Additional Particles */}
        <div 
          style={{ 
            width: '4px', 
            height: '4px', 
            position: 'absolute',
            left: '30%', 
            top: '25%',
            background: 'rgba(255, 255, 255, 0.7)',
            borderRadius: '50%',
            animation: 'particleFloat 10s linear infinite 1s'
          }}
        />
        
        <div 
          style={{ 
            width: '2px', 
            height: '2px', 
            position: 'absolute',
            left: '40%', 
            top: '35%',
            background: 'rgba(255, 255, 255, 0.5)',
            borderRadius: '50%',
            animation: 'particleFloat 18s linear infinite 3s'
          }}
        />

        {/* Background Shapes */}
        <div 
          style={{ 
            width: '200px', 
            height: '200px', 
            position: 'absolute',
            top: '-50px', 
            right: '-50px', 
            background: 'rgba(255, 255, 255, 0.05)',
            borderRadius: '50%',
            animation: 'shapePulse 8s ease-in-out infinite'
          }}
        />
        
        <div 
          style={{ 
            width: '150px', 
            height: '150px', 
            position: 'absolute',
            bottom: '-30px', 
            left: '-30px', 
            background: 'rgba(255, 255, 255, 0.05)',
            borderRadius: '50%',
            animation: 'shapePulse 10s ease-in-out infinite 2s'
          }}
        />

        {/* Additional Shapes */}
        <div 
          style={{ 
            width: '100px', 
            height: '100px', 
            position: 'absolute',
            top: '50%', 
            left: '50%', 
            transform: 'translate(-50%, -50%)',
            background: 'rgba(255, 255, 255, 0.03)',
            borderRadius: '50%',
            animation: 'shapePulse 12s ease-in-out infinite 1s'
          }}
        />
      </div>

      {/* Content - All your components go here */}
      <div className="clickacook-content" style={contentStyles}>
        <Header/>
        <Advertisement/>
        <CulinaryCareerPortal/>
        <CulinaryConnectHero/>
        <Footer/>
      </div>

      {/* CSS Animations */}
      <style>
        {`
          @keyframes backgroundShift {
            0%, 100% {
              transform: scale(1);
              opacity: 0.6;
            }
            50% {
              transform: scale(1.05);
              opacity: 0.8;
            }
          }

          @keyframes floatIngredient {
            0%, 100% {
              transform: translateY(0px) rotate(0deg) scale(1);
            }
            25% {
              transform: translateY(-25px) rotate(5deg) scale(1.1);
            }
            50% {
              transform: translateY(-15px) rotate(-5deg) scale(0.95);
            }
            75% {
              transform: translateY(-20px) rotate(3deg) scale(1.05);
            }
          }

          @keyframes bubbleFloat {
            0%, 100% {
              transform: translateY(0px) scale(1) rotate(0deg);
              opacity: 0.4;
            }
            33% {
              transform: translateY(-30px) scale(1.1) rotate(120deg);
              opacity: 0.6;
            }
            66% {
              transform: translateY(-20px) scale(0.9) rotate(240deg);
              opacity: 0.5;
            }
          }

          @keyframes steamRise {
            0% {
              transform: translateY(0px) scale(0.8);
              opacity: 0;
            }
            20% {
              opacity: 0.3;
            }
            50% {
              opacity: 0.5;
              transform: translateY(-60px) scale(1.2);
            }
            80% {
              opacity: 0.2;
            }
            100% {
              transform: translateY(-120px) scale(1.5);
              opacity: 0;
            }
          }

          @keyframes particleFloat {
            0% {
              transform: translateY(100vh) rotate(0deg);
              opacity: 0;
            }
            10% {
              opacity: 1;
            }
            90% {
              opacity: 1;
            }
            100% {
              transform: translateY(-100px) rotate(360deg);
              opacity: 0;
            }
          }

          @keyframes shapePulse {
            0%, 100% {
              transform: scale(1);
              opacity: 0.03;
            }
            50% {
              transform: scale(1.3);
              opacity: 0.08;
            }
          }

          /* Scrollbar Styling */
          ::-webkit-scrollbar {
            width: 8px;
          }

          ::-webkit-scrollbar-track {
            background: rgba(255, 107, 53, 0.1);
          }

          ::-webkit-scrollbar-thumb {
            background: linear-gradient(135deg, #FF6B35 0%, #FF8E53 100%);
            border-radius: 10px;
          }

          ::-webkit-scrollbar-thumb:hover {
            background: linear-gradient(135deg, #FF8E53 0%, #FF6B35 100%);
          }

          /* Selection Color */
          ::selection {
            background: rgba(255, 107, 53, 0.3);
            color: white;
          }

          ::-moz-selection {
            background: rgba(255, 107, 53, 0.3);
            color: white;
          }

          /* Smooth scrolling */
          html {
            scroll-behavior: smooth;
          }
        `}
      </style>
    </div>
  );
}

export default ClickaCook;
